import { 
    html5FormValidate
} from "../form/js-validation";
import $ from 'jquery';
jQuery.noConflict();

export default class classicAccount {

    /**
     * Show modal for customer account login/register/forgot password
     * @param {*} callback
     */
    openModal(callback) {
        var self = this;

        (function ($) {
            $('#simple-modal-account-login').remove();
            console.log('simple-modal-account-login removed');
            var $accountModal = $('<div class="modal simple-modal" id="simple-modal-account-login">' +
                '<div class="modal-content">' +
                '<span class="close-button">x</span>' +
                '<div class="modal-text">' +
                '</div>' +
                '</div>' +
                '</div>');

            $('body').append($accountModal);

            $.ajax({
                    type: 'GET',
                    url: '/customers/ajax/',
                    dataType: 'html'
                }).done(function (html) {
                    var $modal = $('#simple-modal-account-login');
                    $modal.find('.modal-text').html(html);
                    $modal.toggleClass('show-modal');

                    $('#simple-modal-account-login .close-button').on('click', function () {
                        $(this).closest('.modal').removeClass('show-modal');
                        $('body').css('overflow', 'auto');
                    })

                    html5FormValidate();

                    self.listenForFormSwitch();
                    self.listenForLoginSubmit(callback);
                    self.listenForRegisterSubmit(callback);
                    self.listenForForgotPasswordSubmit();
                })
                .fail(function (jqXHR, textStatus) {
                    // TODO: provide feedback instead of alert
                    alert("Request failed: " + textStatus);
                });
        })(jQuery);
    }

    /**
     * Handle account modal customer login request
     */
    listenForLoginSubmit(callback) {

        (function ($) {
            $('body').off('click', '#form-customer-login .btn-login').on('click', '#form-customer-login .btn-login', function (e) {
                e.preventDefault();

                var $this = $(this);
                var buttonText = $this.html();

                $this.html('Logging In...');
                $this.attr('disabled', 'disabled');

                // Clear alert HTML
                $('#account-modal-alerts').hide().html('');

                html5FormValidate();

                $.ajax({
                        type: 'POST',
                        url: '/customers/ajax/login/',
                        dataType: 'json',
                        data: $this.closest('form').serialize()
                    }).done(function (data) {
                        if (typeof data.success !== 'undefined' && data.success) {
                            if (!!data.message) {
                                $('#account-modal-alerts').removeClass('alert-danger').addClass('alert-success').html(data.message).show();
                            }

                            var $modal = $('#simple-modal-account-login');
                            $modal.removeClass('show-modal');

                            if (!!callback) {
                                callback();
                            }
                        } else if ( typeof data.error !== 'undefined' && !Boolean(data.error) ) {
                            $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.error).show();
                        } else if (typeof data.message !== 'undefined' && !!data.message ) {
                            $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.message).show();
                        } else {
                            $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html('There was a problem. Please try again.').show();
                        }

                        $this.html(buttonText);
                        $this.removeAttr('disabled');

                        return data;
                    })
                    .fail(function (jqXHR, textStatus) {
                        // TODO: provide feedback instead of alert
                        alert("Request failed: " + textStatus);
                    });
            });
        })(jQuery);
    }

    /**
     * Handle account modal customer registration request
     */
    listenForRegisterSubmit(callback) {

        (function ($) {
			$('body').off('click', '#form-customer-register .btn-register').on('click', '#form-customer-register .btn-register', function (e) {
                e.preventDefault();

                var $this = $(this);
                var buttonText = $this.html();

                $this.html('Submitting...');
                $this.attr('disabled', 'disabled');

                // Clear alert HTML
                $('#account-modal-alerts').hide().html('');

                $('#form-customer-register #confirm_email').val($('#form-customer-register #register-email').val());
                $('#form-customer-register #confirmation').val($('#form-customer-register #register-password').val());

                html5FormValidate();

                // Check if reCAPTCHA is available and execute before submitting
                console.log('reCAPTCHA Debug:', {
                    grecaptcha: typeof grecaptcha !== 'undefined',
                    enterprise: typeof grecaptcha !== 'undefined' && grecaptcha.enterprise,
                    siteKey: window.recaptchaSiteKey
                });
                
                if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise && window.recaptchaSiteKey) {
                    console.log('reCAPTCHA: Executing token generation');
                    grecaptcha.enterprise.ready(async () => {
                        try {
                            const token = await grecaptcha.enterprise.execute(window.recaptchaSiteKey, {action: 'REGISTER'});
                            console.log('reCAPTCHA: Token generated successfully');
                            
                            // Add reCAPTCHA token to form data
                            var formData = $('#form-customer-register').serialize() + '&recaptcha_token=' + encodeURIComponent(token);

                        $.ajax({
                                type: 'POST',
                                url: '/customers/ajax/create/',
                                dataType: 'json',
                                data: formData
                            }).done(function (data) {
                        if (typeof data.success !== 'undefined') {
                            if (data.success) {
                                if (typeof gtag !== "undefined") {
                                    gtag("event", "sign_up", {
                                        method: "Account Signup - Modal"
                                    });
                                }

                                if (!!data.message) {
                                    $('#account-modal-alerts').removeClass('alert-danger').addClass('alert-success').html(data.message).show();
                                }

                                setTimeout(function(){
                                    var $modal = $('#simple-modal-account-login');
                                    
                                    // Check if email confirmation is required
                                    if (data.confirmation_required === true) {
                                        // Keep modal open - user needs to confirm email first
                                        // Message is already shown in the alerts area
                                        return;
                                    }

                                    // User was logged in successfully - close modal and redirect to account page
                                    $modal.removeClass('show-modal');
                                    // Use redirect URL from backend if provided, otherwise use default
                                    var redirectUrl = data.redirect || '/customer/account/index';
                                    window.location.href = redirectUrl;
                                }, 2000);

                            } else {
                                if ( typeof data.error !== 'undefined' ) {
                                    $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.error + "").show();
                                } else if (typeof data.message !== 'undefined' ) {
                                    $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.message).show();
                                }
                            }
                        } else {
                            // TODO: provide feedback
                            $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html('There was a problem. Please try again.').show();

                            $this.html(buttonText);
                            $this.removeAttr('disabled');
                        }

                        $this.html(buttonText);
                        $this.removeAttr('disabled');
                        return data;
                    })
                    .fail(function (jqXHR, textStatus) {
                        // TODO: provide feedback instead of alert
                        alert("Request failed: " + textStatus);
                        $this.html(buttonText);
                        $this.removeAttr('disabled');
                    });
                    
                    } catch (error) {
                        console.error('reCAPTCHA error:', error);
                        $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html('Something went wrong. Please try again.').show();
                        $this.html(buttonText);
                        $this.removeAttr('disabled');
                    }
                });
                } else {
                    // reCAPTCHA is disabled, submit form without token
                    console.log('reCAPTCHA: Submitting without token (disabled or not available)');
                    $.ajax({
                            type: 'POST',
                            url: '/customers/ajax/create/',
                            dataType: 'json',
                            data: $('#form-customer-register').serialize()
                        }).done(function (data) {
                            if (typeof data.success !== 'undefined') {
                                if (data.success) {
                                    if (typeof gtag !== "undefined") {
                                        gtag("event", "sign_up", {
                                            method: "Account Signup - Modal"
                                        });
                                    }

                                    if (!!data.message) {
                                        $('#account-modal-alerts').removeClass('alert-danger').addClass('alert-success').html(data.message).show();
                                    }

                                    setTimeout(function(){
                                        var $modal = $('#simple-modal-account-login');
                                        
                                        // Check if email confirmation is required
                                        if (data.confirmation_required === true) {
                                            // Keep modal open - user needs to confirm email first
                                            // Message is already shown in the alerts area
                                            return;
                                        }

                                        // User was logged in successfully - close modal and redirect to account page
                                        $modal.removeClass('show-modal');
                                        // Use redirect URL from backend if provided, otherwise use default
                                        var redirectUrl = data.redirect || '/customer/account/index';
                                        window.location.href = redirectUrl;
                                    }, 2000);

                                } else {
                                    if ( typeof data.error !== 'undefined' ) {
                                        $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.error + "").show();
                                    } else if (typeof data.message !== 'undefined' ) {
                                        $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.message).show();
                                    }
                                }
                            } else {
                                $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html('Something went wrong. Please try again.').show();
                            }

                            $this.html(buttonText);
                            $this.removeAttr('disabled');
                        })
                        .fail(function (jqXHR, textStatus) {
                            alert("Request failed: " + textStatus);
                            $this.html(buttonText);
                            $this.removeAttr('disabled');
                        });
                }
            });
        })(jQuery);
    }

    /**
     * Handle account modal customer forgot password request
     */
    listenForForgotPasswordSubmit() {

        (function ($) {
			$('body').off('click', '#form-forgot-password .btn-reset-password').on('click', '#form-forgot-password .btn-reset-password', function (e) {
                e.preventDefault();

                var $this = $(this);
                var buttonText = $this.html();

                $this.html('Submitting...');
                $this.attr('disabled', 'disabled');
                $('#account-modal-alerts').hide().html('');

                html5FormValidate();

                $.ajax({
                        type: 'POST',
                        url: '/customers/ajax/forgotpassword/',
                        dataType: 'json',
                        data: $('#form-forgot-password').serialize()
                    }).done(function (data) {
                        if (typeof data.success !== 'undefined') {
                            if (data.success) {

                                $('#account-modal-alerts').removeClass('alert-danger').addClass('alert-success').html("Success! If there is an account associated with that email, instructions for resetting your password will be sent there.").show();

                                if (!!data.message) {
                                    $('#account-modal-alerts').removeClass('alert-danger').addClass('alert-success').html(data.message).show();
                                }

                                var $modal = $('#simple-modal-account-login');

                            } else {
                                if ( typeof data.error !== 'undefined' ) {
                                    $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.error).show();
                                } else if (typeof data.message !== 'undefined' ) {
                                    $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html(data.message).show();
                                }
                            }
                        } else {
                            $('#account-modal-alerts').removeClass('alert-success').addClass('alert-danger').html('There was a problem. Please try again.').show();
                        }

                        $this.html(buttonText);
                        $this.removeAttr('disabled');

                        return data;
                    })
                    .fail(function (jqXHR, textStatus) {
                        // TODO: provide feedback instead of alert
                        alert("Request failed: " + textStatus);
                    });
            });
        })(jQuery);
    }

    /**
     * Listen for account modal forms and show/hide appropriate forms
     */
    listenForFormSwitch() {
        (function ($) {
            // Scope to header drawer and ajax modal only. The standalone login page also
            // uses .account-login on a wrapper div; an unscoped $('.account-login').bind
            // catches bubbled clicks and preventDefault() blocks real links (e.g. Create Account).
            var ns = '.cfAccountSwitch';
            var $switchRoots = $('.cart-drawer, #simple-modal-account-login');

            $switchRoots.find('#forgot-password')
                .off('click' + ns)
                .on('click' + ns, function (e) {
                    e.preventDefault();
                    $('#form-forgot-password').show();
                    $('#form-customer-login').hide();
                    $('#form-customer-register').hide();
                    $('#account-modal-alerts').hide().html('');
                });

            $switchRoots.find('#new-account-register')
                .off('click' + ns)
                .on('click' + ns, function (e) {
                    e.preventDefault();
                    $('#form-forgot-password').hide();
                    $('#form-customer-login').hide();
                    $('#form-customer-register').show();
                    $('#account-modal-alerts').hide().html('');
                });

            $switchRoots.find('.account-login')
                .off('click' + ns)
                .on('click' + ns, function (e) {
                    e.preventDefault();
                    $('#form-forgot-password').hide();
                    $('#form-customer-login').show();
                    $('#form-customer-register').hide();
                    $('#account-modal-alerts').hide().html('');
                });
        })(jQuery);
    }
};